import { ReactNode } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Lock } from "lucide-react";
import { useCardsStatus } from "@/hooks/useCardsStatus";
import CardsComingSoon from "@/components/cards/CardsComingSoon";

/**
 * Blocks in-app Virtual Card surfaces (issue / top-up / manage) with a
 * "Coming Soon" state while `cards_live` is off.
 */
export default function CardsGate({ children, source }: { children: ReactNode; source?: string }) {
  const { locked, loading } = useCardsStatus();
  if (loading) return null;
  if (locked) {
    return (
      <div className="p-4 sm:p-6">
        <CardsComingSoon source={source ?? "cards"} />
      </div>
    );
  }
  return <>{children}</>;
}

/** For surfaces that stay readable while issuing is locked. */
export function CardsLockedNotice({ className }: { className?: string }) {
  const { locked } = useCardsStatus();
  if (!locked) return null;
  return (
    <Alert className={className}>
      <Lock className="h-4 w-4" />
      <AlertTitle>The ACEX Card is launching soon</AlertTitle>
      <AlertDescription>
        Card issuing and top-ups stay locked until the card goes live. We'll email everyone on the waitlist.
      </AlertDescription>
    </Alert>
  );
}
